import React from 'react';
import PropTypes from 'prop-types';
import Select from '../Select';
import COUNTRIES from '../../../constants/countries';


const CountryDropdown = ({ value, onChange }) => (
  <Select
    value={value}
    onChange={onChange}
    options={[...COUNTRIES, 'Other']}
  />
);

CountryDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default CountryDropdown;


// WEBPACK FOOTER //
// src/components/shared/CountryDropdown/index.jsx